import packageJson from '../../package.json'

const env = process.env.REACT_APP_NODE_ENV

const localDevApi = {
  auth: 'https://9dyo3sdpol.execute-api.sa-east-1.amazonaws.com',
  payments: 'https://tv9bafmtch.execute-api.us-east-2.amazonaws.com/dev',
  customers: 'https://fevk01at78.execute-api.us-east-2.amazonaws.com/dev',
  documents: 'https://ismnbtcdbc.execute-api.us-east-2.amazonaws.com/dev',
  systemUsers: 'https://kfkcn7ijqk.execute-api.us-east-2.amazonaws.com/dev'
}

export const config =
  env === 'local'
    ? {
        environment: env,
        secret: process.env.REACT_APP_LOCAL_DB_SECRET,
        ethereumNetwork: {
          blockExplorerUrl: 'https://sepolia.etherscan.io'
        },
        tronNetwork: {
          fullNode: process.env.REACT_APP_TRON_FULL_NODE,
          blockExplorerUrl: 'https://shasta.tronscan.org',
          eventServer: process.env.REACT_APP_TRON_EVENT_SERVER,
          solidityNode: process.env.REACT_APP_TRON_SOLIDITY_NODE
        },
        app: {
          version: packageJson.version,
          paxumCompanyId: process.env.REACT_APP_PAXUM_COMPANY_ID,
          isliveCompanyId: process.env.REACT_APP_ISLIVE_COMPANY_ID,
          demoPaxumCompanyId: process.env.REACT_APP_DEMO_PAXUM_COMPANY_ID,
          scienciatechCompanyId: process.env.REACT_APP_SCIENCIATECH_COMPANY_ID,
          demoScienciatechCompanyId: process.env.REACT_APP_DEMO_SCIENCIATECH_COMPANY_ID
        },
        api: {
          auth: {
            baseUrl: process.env.REACT_APP_AUTH_BASE_URL || localDevApi.auth
          },
          payments: {
            baseUrl: process.env.REACT_APP_PAYMENTS_BASE_URL || localDevApi.payments
          },
          customers: {
            baseUrl: process.env.REACT_APP_CUSTOMERS_BASE_URL || localDevApi.customers
          },
          documents: {
            baseUrl: process.env.REACT_APP_DOCUMENTS_BASE_URL || localDevApi.documents
          },
          systemUsers: {
            baseUrl: process.env.REACT_APP_SYSTEM_USERS_BASE_URL || localDevApi.systemUsers
          },
          appData: {
            baseUrl: 'https://app-data-dev.adamoservices.co'
          }
        },
        // realm: {
        //   dbName: 'adamo-pay-test',
        //   payments: {
        //     appId: 'adamo-pay-payments-flfwg'
        //   },
        //   customers: {
        //     appId: 'adamo-pay-customers-eidim'
        //   },
        //   documents: {
        //     appId: 'adamo-pay-documents-vmapz'
        //   },
        //   systemUsers: {
        //     appId: 'adamo-pay-system-users-qsbfv'
        //   },
        //   dataToApprove: {
        //     appId: 'adamo-pay-data-to-approve-dbgrl'
        //   },
        //   unidentifiedCustomers: {
        //     appId: 'adamo-pay-unidentified-customers-dqtev'
        //   }
        // },
        socket: {
          secure: true,
          url: 'https://excel-document-reader-dev.adamoservices.co'
        },
        appDataSocket: {
          secure: true,
          url: 'https://app-data-dev.adamoservices.co'
        }
      }
    : env === 'development'
      ? {
          environment: env,
          secret: process.env.REACT_APP_LOCAL_DB_SECRET,
          ethereumNetwork: {
            blockExplorerUrl: 'https://sepolia.etherscan.io'
          },
          tronNetwork: {
            fullNode: process.env.REACT_APP_TRON_FULL_NODE,
            blockExplorerUrl: 'https://shasta.tronscan.org',
            eventServer: process.env.REACT_APP_TRON_EVENT_SERVER,
            solidityNode: process.env.REACT_APP_TRON_SOLIDITY_NODE
          },
          app: {
            version: packageJson.version,
            paxumCompanyId: process.env.REACT_APP_PAXUM_COMPANY_ID,
            isliveCompanyId: process.env.REACT_APP_ISLIVE_COMPANY_ID,
            demoPaxumCompanyId: process.env.REACT_APP_DEMO_PAXUM_COMPANY_ID,
            scienciatechCompanyId: process.env.REACT_APP_SCIENCIATECH_COMPANY_ID,
            demoScienciatechCompanyId: process.env.REACT_APP_DEMO_SCIENCIATECH_COMPANY_ID
          },
          api: {
            auth: {
              baseUrl: 'https://9dyo3sdpol.execute-api.sa-east-1.amazonaws.com'
            },
            payments: {
              baseUrl: 'https://tv9bafmtch.execute-api.us-east-2.amazonaws.com/dev'
            },
            customers: {
              baseUrl: 'https://fevk01at78.execute-api.us-east-2.amazonaws.com/dev'
            },
            documents: {
              baseUrl: 'https://ismnbtcdbc.execute-api.us-east-2.amazonaws.com/dev'
            },
            systemUsers: {
              baseUrl: 'https://kfkcn7ijqk.execute-api.us-east-2.amazonaws.com/dev'
            },
            appData: {
              baseUrl: 'https://app-data-dev.adamoservices.co'
            }
          },
          // realm: {
          //   dbName: 'adamo-pay-test',
          //   payments: {
          //     appId: 'adamo-pay-payments-flfwg'
          //   },
          //   customers: {
          //     appId: 'adamo-pay-customers-eidim'
          //   },
          //   documents: {
          //     appId: 'adamo-pay-documents-vmapz'
          //   },
          //   systemUsers: {
          //     appId: 'adamo-pay-system-users-qsbfv'
          //   },
          //   dataToApprove: {
          //     appId: 'adamo-pay-data-to-approve-dbgrl'
          //   },
          //   unidentifiedCustomers: {
          //     appId: 'adamo-pay-unidentified-customers-dqtev'
          //   }
          // },
          socket: {
            secure: true,
            url: 'https://excel-document-reader-dev.adamoservices.co'
          },
          appDataSocket: {
            secure: true,
            url: 'https://app-data-dev.adamoservices.co'
          }
        }
      : {
          environment: env,
          secret: process.env.REACT_APP_LOCAL_DB_SECRET,
          ethereumNetwork: {
            blockExplorerUrl: 'https://etherscan.io'
          },
          tronNetwork: {
            blockExplorerUrl: 'https://tronscan.org',
            fullNode: process.env.REACT_APP_TRON_FULL_NODE,
            eventServer: process.env.REACT_APP_TRON_EVENT_SERVER,
            solidityNode: process.env.REACT_APP_TRON_SOLIDITY_NODE
          },
          app: {
            version: packageJson.version,
            paxumCompanyId: process.env.REACT_APP_PAXUM_COMPANY_ID,
            isliveCompanyId: process.env.REACT_APP_ISLIVE_COMPANY_ID,
            scienciatechCompanyId: process.env.REACT_APP_SCIENCIATECH_COMPANY_ID
          },
          api: {
            auth: {
              baseUrl: 'https://9dyo3sdpol.execute-api.sa-east-1.amazonaws.com'
            },
            payments: {
              baseUrl: 'https://i6luw43zvl.execute-api.us-east-2.amazonaws.com/prod'
            },
            customers: {
              baseUrl: 'https://vfu9ka73gb.execute-api.us-east-2.amazonaws.com/prod'
            },
            documents: {
              baseUrl: 'https://47qxdoyet4.execute-api.us-east-2.amazonaws.com/prod'
            },
            systemUsers: {
              baseUrl: 'https://cq8ahlq1k3.execute-api.us-east-2.amazonaws.com/prod'
            },
            appData: {
              baseUrl: 'https://app-data.adamoservices.co'
            }
          },
          // realm: {
          //   dbName: 'adamo-pay',
          //   payments: {
          //     appId: 'adamo-pay-payments-prod-uzeajsr'
          //   },
          //   customers: {
          //     appId: 'adamo-pay-customers-prod-tchaute'
          //   },
          //   documents: {
          //     appId: 'adamo-pay-documents-prod-txelvib'
          //   },
          //   systemUsers: {
          //     appId: 'adamo-pay-system-users-prod-tvreynf'
          //   },
          //   dataToApprove: {
          //     appId: 'adamo-pay-data-to-approve-prod-jxcjilv'
          //   },
          //   unidentifiedCustomers: {
          //     appId: 'a-pay-unidentified-customer-prod-malzwql'
          //   }
          // },
          socket: {
            secure: true,
            url: 'https://excel-document-reader.adamoservices.co'
          },
          appDataSocket: {
            secure: true,
            url: 'https://app-data.adamoservices.co'
          }
        }
